import * as client from "_graphql-types";
import { filterSortPage } from "../DataProvider";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/

async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.InvestmentTagsSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    investmentTagsList: { items: data, total },
  } = await sdk.getListInvestmentTags(
    filterSortPage({ filter, sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/

async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);

  const { investmentTags: data } = await sdk.getOneInvestmentTags({
    id,
  });
  return { data };
}

/*********************************************************************/

async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));
  const { investmentTagsMany: data } = await sdk.getManyInvestmentTags({
    ids,
  });
  return { data };
}

/*********************************************************************/

export const investmentTags = types.dataProvider({
  getOne,
  getMany,
  getList,
});
